export default __webpack_public_path__ + "static/media/6.c8ccef64.jpg";